<template>
	<v-container>
		<v-alert v-if="false" dense outlined type="error">
			No se encuentran <strong>datos</strong> para el dia <strong> {{ viewRangeDate | dateFormat }} </strong>
		</v-alert>
		<v-row dense>
			<v-col cols="12" sm="5" v-if="showProjects">
				<v-select v-model="selectProject" :items="projects" item-text="name" item-value="projectId" chips
					label="Proyectos" outlined>
				</v-select>
			</v-col>
			<v-col cols="12" sm="5">
				<v-select v-model="selectDevices" :items="devices" item-text="name" item-value="deviceId" chips
					label="Dispositivos" multiple outlined>
					<template #selection="{ item }">
						<v-chip dark :color="colorChip(item)">{{ item.name }}</v-chip>
					</template>
				</v-select>
			</v-col>
			<v-col cols="12" sm="2" align="center" justify="center">
				<v-btn style="margin-top: 15px;" depressed color="primary" @click="getDevicesData" :disabled="!hasSelectedDevices">
					Comparar
				</v-btn>
			</v-col>
			<v-col cols="12" v-show="isLoading">
				<v-skeleton-loader type="image"></v-skeleton-loader>
				<v-skeleton-loader type="image"></v-skeleton-loader>
			</v-col>
			<v-col cols="12" v-show="!isLoading">
				<apexchart ref="chart" height="400px" :options="options" :series="series"></apexchart>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import moment from 'moment'
import VueApexCharts from 'vue-apexcharts'

export default {
	name: 'Resume',

	data: () => ({
		options: {
			colors: ['#E53935', '#1E88E5', '#5c54a4', '#87ceff', '#1E88E5', '#5c54a4', '#87ceff', '#86BBF9', '#2EC1D5', '#67D148', '#A82332', '#CCF658'],
			markers: {
				showNullDataPoints: false,
			},
			stroke: {
				width: [2, 2, 2, 2, 2],
				curve: 'straight'
			},
			chart: {
				type: 'line',
				id: 'hA',
				group: 'social',
			},
			yaxis: {
				labels: {
					minWidth: 0,
					formatter: function (value) {
						return value.toFixed(1) + ""
					}
				},
				title: {
					text: 'Decibeles [dBA]',
				},
			},
			annotations: {
				xaxis: [],
				points: []
			},
			xaxis: {
				type: 'datetime',
				tickAmount: 1,
				labels: {
					show: true
				}
			},
			tooltip: {
			},
		},
		series: [],
		Laeqfs: [],
		selectDevices: [],
		selectProject: []
	}),

	methods: {
		getDevicesData() {
			let payload = {
				devices: this.selectDevices,
				loading: true,
				...this.viewRangeDate
			}

			this.$store.dispatch('handleLoading', true)
			this.$store.dispatch('pullDeviceDateResumeReport', payload)
		},

		dataCharts(data) {
			this.options.annotations.xaxis = []
			this.options.annotations.points = []

			this.$refs.chart.updateOptions({
				annotations: {
					points: [],
					xaxis: []
				}
			})

			this.series = []
			let isEmpty = true

			for (let j = 0; j < data.length; j++) {
				let Laeqfs = []
				const devicesInfo = this.findDeviceInfo(data[j].deviceId)

				const laeqSensor = devicesInfo.sensors.find(e => {
					return e.sensorType === 'laeq'
				}).sensorName

				let offsetloco = this.laeqOffset(data[j].deviceId, laeqSensor)
				const info = data[j].info.data

				if (info.length === 0)
					continue

				isEmpty = false

				for (let i = 0; i < info.length; i++) {
					const laqeValue = info[i].report.LASeq + offsetloco
					let laqeValuePre = laqeValue

					if (i > 0)
						laqeValuePre = info[i - 1].report.LASeq + offsetloco

					let laeqSensorValue
					let laeqFilter

					if (!Object.hasOwnProperty.call(devicesInfo, "laeqFilter")) {
						laeqFilter = {
							max: 100,
							min: 0
						}
					} else {
						laeqFilter = devicesInfo.laeqFilter
					}

					if (laqeValue > laeqFilter.max || laqeValue < laeqFilter.min)
						laeqSensorValue = null
					else
						laeqSensorValue = laqeValue

					Laeqfs.push({
						str: info[i].ts,
						x: new Date(info[i].ts).getTime(),
						y: laeqSensorValue
					})
				}

				this.series.push({
					type: 'line',
					name: `Nivel sonoro equivalente ${devicesInfo.name}`,
					color: devicesInfo.info.color,
					data: Laeqfs
				})
			}

			if (isEmpty) {
				this.$store.dispatch('customNotification', { text: 'Sin datos para el mes seleccionado.', color: 'warning' })
			}

			this.series.sort((a, b) => b._p - a._p)
			this.$store.dispatch('handleLoading', false)
		},
		
		extremesCharts(extremes) {
			let infoView = {
				"max": [],
				"min": []
			}

			this.infoExtremeView = {}
			this.extremesElements = []

			if (extremes.length === 0)
				return

			for (let i = 0; i < extremes.length; i++) {
				const element = extremes[i]

				infoView["max"].push({
					x: new Date(element.ts).getTime(),
					y: element.report.max.value
				})

				infoView["min"].push({
					x: new Date(element.ts).getTime(),
					y: element.report.min.value
				})

				this.exportData[i]["lmax"] = +element.report.max.value.toFixed(1)
				this.exportData[i]["lmin"] = +element.report.min.value.toFixed(1)
			}

			this.infoExtremeView = infoView
		},
		
		laeqOffset(deviceId, sensorName) {
			const findSensor = this.allSensors.filter(sensor => sensor.deviceId === deviceId && sensor.sensorName === sensorName)

			if (findSensor.length > 0)
				return findSensor[0].offset

			return 0
		},

		findDeviceInfo(deviceId) {
			return this.$store.getters.device(deviceId)
		},

		colorChip(item) {
			if ( ('info' in item ) && ( 'color' in item.info))
				return item.info.color

			let index = this.selectDevices.indexOf(item.deviceId)
			return this.options.colors[index]
		}
	},

	computed: {
		viewRangeDate() {
			return this.$store.getters.viewRangeDate
		},

		isLoading() {
			return this.$store.getters.isLoading
		},

		hasSelectedDevices () {
			return this.selectDevices.length > 0
		},

		devices() {
			return this.$store.getters.devices
		},

		devicesDateResume() {
			return this.$store.getters.devicesDateResumeReport
		},

		allSensors() {
			return this.$store.getters.allSensors
		},

		projects() {
			return this.$store.getters.projects
		},

		showProjects() {
			return this.projects.length > 0
		},
	},

	watch: {
		devicesDateResume(val) {
			this.dataCharts(val)
		},
		selectProject(val){
			let deviceByProject = this.devices.filter ( e => e.projectId === val)
			this.selectDevices = deviceByProject.map( e => e.deviceId )
		}
	},

	filters: {
		dateFormat(val) {
			if (!moment(val).isValid())
				return val

			return moment(val).format('LL')
		},
	},

	components: {
		apexchart: VueApexCharts
	},

	created() {

		moment.locale('es-us')
	}
}
</script>